import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  emptyState: 'Select element to edit',
  source: 'Source:',
  startTime: 'Start time',
  endTime: 'End time',
  title: 'Title:',
  save: 'Save',
  delete: 'Delete',
  question: 'Question:',
  questionPlaceholder: 'Choice question',
  option: 'Option:',
  deleteAnswer: 'Delete answer',
  gradeWeight: 'Score weight',
  isCorrect: 'Correct answer?',
  areYouSureDeleteVideo:
    'Delete this video source and its child nodes? (Cannot be undone)',
  areYouSureDeleteImageSource:
    'Delete this image source and its child nodes? (Cannot be undone)',
  areYouSureDeleteVideoSoft:
    'Delete this video source only and keep its child nodes? (Cannot be undone)',
  areYouSureDeleteImageSourceSoft:
    'Delete this image source only and keep its child nodes? (Cannot be undone)',
  areYouSureDeleteVideoSoftBranchParent:
    'Deleting the current source will require revising any existing child nodes linked to it. Do you want to continue knowing these changes are necessary?',
  areYouSureDeleteChoiceQuestion:
    'Delete this choice question and its child nodes? (Cannot be undone)',
  areYouSureDeleteChoiceTextOption:
    'Delete this choice text option and its child nodes? (Cannot be undone)',
  areYouSureDeleteVideoBackgorundOption:
    'Delete this video backgorund choice and its child nodes? (Cannot be undone)',
  areYouSureDeleteChoiceImageOption:
    'Delete this choice image option and its child nodes? (Cannot be undone)',
  areYouSureDeleteChoiceShapeOption:
    'Delete this choice shape option and its child nodes? (Cannot be undone)',
  areYouSureDeleteChallengeImageOption:
    'Delete this challenge image option and its child nodes? (Cannot be undone)',
  areYouSureDeleteChoiceHeaderOption:
    'Delete this choice branch and its child nodes? (Cannot be undone)',
  areYouSureDeleteChallengeHeaderOption:
    'Delete this challenge branch and its child nodes? (Cannot be undone)',
  areYouSureDeleteAcknowledgment:
    'Delete this acknowledgment and its child nodes? (Cannot be undone)',
  areYouSureDeleteAcknowledgmentSoft:
    'Delete this acknowledgment only and keep its child nodes? (Cannot be undone)',
  areYouSureDeleteJumpToOption:
    'Delete this jump to and its child nodes? (Cannot be undone)',
  areYouSureDeleteJumpToOptionSoft:
    'Delete this jump to only and keep its child nodes? (Cannot be undone)',
  choiceBranchHeaderText: 'Choice branch',
  challangeBranchHeaderText: 'Challenge branch',
  editSource: 'Edit source',
  editSourceWithOverlay: 'Edit source with overlay',
  editOverlay: 'Edit overlay',
  preview: 'Preview',
  answerTitle: 'Answers:',
  answerPlaceholder: 'Add multiple choice answer',
  areYouSureDeleteMChoice:
    'Delete this multiple choice question and its child nodes? (Cannot be undone)',
  areYouSureDeleteMChoiceSoft:
    'Delete this multiple choice question only and keep its child nodes? (Cannot be undone)',
  videoNodeTooltip: 'Video source',
  recordVideoTooltip: 'Record video',
  recordVideoTitle: 'Record video',
  reRecordVideo: 'New recording',
  saveAndProceed: 'Save & proceed',
  cameraPermissionError:
    'Camera or microphone access was denied. Please allow access in your browser settings and try again.',
  retryRecording: 'Retry',
  closeRecording: 'Close',
  uploadRecordingFailed: 'Failed to upload recorded video',
  uploadingRecording: 'Uploading recorded video...',
  choiceImageNodeTooltip: 'Choice option image',
  choiceTextNodeTooltip: 'Choice option text',
  choiceShapeNodeTooltip: 'Choice option shape',
  videoBackground: 'Choice video background',
  videoBackgroundShort: 'Video background',
  choiceNodeTooltip: 'Choice branch',
  choiceQuestionNodeTooltip: 'Choice branch question',
  mChoiceNodeTooltip: 'Multiple choice question',
  disclaimer:
    '*Maximum 4, with at least 1 answer correct. No duplicate answers',
  addAnswer: 'Add answer',
  challengeBranchQuestionTooltip: 'Challenge branch question',
  challengeBranchTextOption: 'Challenge text answer',
  challengeBranchImageOption: 'Challenge image answer',
  challengeBranchAITooltip: 'Challenge branch AI',
  cantProceedTooltip: 'New nodes cannot be added to a published lesson',
  videoOverlay: 'Video source with overlay',
  titlePlaceholder: 'Title',
  jumpToNodeTooltip: 'Jump to',
  lessonNodes: 'Lesson nodes:',
  duplicateBackgorundOption: 'Duplicate background option found',
  acknowledgmentNode: 'Acknowledgment',
  acknowledgmentText: 'Acknowledgment text',
  acknowledgmentTextPlaceholder:
    'Input your text that describes the terms and conditions of this acknowledgment node',
  acknowledgmentButton: 'Accept button title',
  acknowledgmentButtonPlaceholder:
    'Set the title of the button i.e. Accept, OK, Acknowledge, Confirm, etc.',
  replace: 'Replace node',
  maxImageDuration: 'Maximum: 3 minutes',
  openendedNodeTooltip: 'Open-ended question (upload a file)',
  textAreaAnswerEnabled: 'Text area answer enabled',
  textAreaAnswerPrompt: 'Prompt for text area answer',
  maxCharacterCount: 'Max character count',
  attachmentAnswerEnabled: 'Attachment answer enabled',
  attachmentAnswerPrompt: 'Prompt for attachment answer',
  maxFileSizeKb: 'Max file size in KB',
  gradeWeightEnabled: 'Grade weight enabled',
  openEndedQuestionDefaultTestAreaPrompt:
    'Please upload your thoughts on the video lesson so far',
  openEndedQuestionDefaultAttachmentPrompt:
    'Submit a file that answers the following question',
  openEndedQuestionErrorBothPromptsDisabled:
    'Both textarea and attachment options disabled',
  attachmentAnswerFileTypes: 'File extensions (comma or semicolon separated):',
};

const welsh = {
  emptyState: "Dewiswch elfen i'w olygu",
  source: 'Ffynhonnel:',
  startTime: 'Amser dechrau',
  endTime: 'Amser gorffen',
  title: 'Teitl:',
  save: 'Cadw',
  delete: 'Dileu',
  question: 'Cwestiwn:',
  questionPlaceholder: 'Cwestiwn dewis',
  option: 'Opsiwn',
  deleteAnswer: 'Dileu ateb',
  gradeWeight: 'Pwysau sgôr',
  isCorrect: 'Ateb Cywir?',
  areYouSureDeleteVideo:
    "Dileu'r ffynhonnell fideo hon a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteImageSource:
    "Dileu'r ffynhonnell ddelwedd hon a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteVideoSoft:
    "Dileu'r ffynhonnell fideo hon yn unig a chadw ei nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteImageSourceSoft:
    "Dileu'r ffynhonnell ddelwedd hon yn unig a chadw ei nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChoiceQuestion:
    "Dileu'r cwestiwn dewis hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChoiceTextOption:
    "Dileu'r opsiwn testun dewis hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteVideoBackgorundOption:
    "Dileu'r dewis cefndir fideo hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChoiceImageOption:
    "Dileu'r opsiwn ddelwedd dewis hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChoiceShapeOption:
    "Dileu'r opsiwn siâp dewis hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChallengeImageOption:
    "Dileu'r opsiwn ddelwedd her hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChoiceHeaderOption:
    "Dileu'r gangen dewis hon a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteChallengeHeaderOption:
    "Dileu'r gangen her hon a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteAcknowledgment:
    "Dileu'r cydnabyddiaeth hon a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteAcknowledgmentSoft:
    "Dileu'r cydnabyddiaeth hon yn unig a chadw ei nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteJumpToOption:
    "Dileu'r 'neidi at' hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteJumpToOptionSoft:
    "Dileu'r 'neidio at' hwn yn unig a chadw ei nodau plant? (Ni ellir ei adfer)",
  choiceBranchHeaderText: 'Cangen dewis',
  challangeBranchHeaderText: 'Cangen her',
  editSource: 'Golygu ffynhonnell',
  editSourceWithOverlay: 'Golygu ffynhonnell gyda throshaen',
  editOverlay: 'Golygu troshaen',
  preview: 'Rhagolwg',
  answerTitle: 'Atebion:',
  answerPlaceholder: 'Ychwanegwch ateb amlddewis',
  areYouSureDeleteMChoice:
    "Dileu'r cwestiwn amlddewis hwn a'i nodau plant? (Ni ellir ei adfer)",
  areYouSureDeleteMChoiceSoft:
    "Dileu'r cwestiwn amlddewis hwn yn unig a chadw ei nodau plant? (Ni ellir ei adfer)",
  videoNodeTooltip: 'Fffynhonnell fideo',
  recordVideoTooltip: 'Recordio fideo',
  recordVideoTitle: 'Recordio fideo',
  reRecordVideo: 'Recordiad newydd',
  saveAndProceed: 'Cadw a pharhau',
  cameraPermissionError:
    "Gwrthodwyd mynediad i'r camera neu'r meicroffon. Caniatewch fynediad yn eich gosodiadau porwr a rhowch gynnig arall arni.",
  retryRecording: 'Ailgynnig',
  closeRecording: 'Cau',
  uploadRecordingFailed: "Methwyd ag uwchlwytho'r fideo a recordiwyd",
  uploadingRecording: "Uwchlwytho'r fideo a recordiwyd...",
  choiceImageNodeTooltip: 'Delwedd opsiwn dewis',
  choiceTextNodeTooltip: 'Testun opsiwn dewis',
  choiceShapeNodeTooltip: 'Siâp opsiwn dewis',
  videoBackground: 'Cefndir fideo ppsiwn',
  videoBackgroundShort: 'Cefndir fideo',
  choiceNodeTooltip: 'Gangen dewis',
  choiceQuestionNodeTooltip: 'Cwestiwn gangen dewis',
  mChoiceNodeTooltip: 'Cwestiwn amlddewis',
  disclaimer: 'Uchafswm o 4, gyda o leiaf 1 ateb cywir. Dim atebion dyblyg',
  addAnswer: 'Ychwanegwch ateb',
  challengeBranchQuestionTooltip: 'Cwestiwn cangen her',
  challengeBranchTextOption: 'Cwestiwn testun her',
  challengeBranchImageOption: 'Cwestiwn delwedd her',
  challengeBranchAITooltip: 'Cangen her AI',
  cantProceedTooltip:
    'Ni ellir ychwanegu nodau newydd at wers sydd wedi’i chyhoeddi.',
  videoOverlay: 'Ffynhonnell fideo gyda throshaen',
  titlePlaceholder: 'Teitl',
  jumpToNodeTooltip: 'Neidio at',
  lessonNodes: 'Nodau gwers',
  duplicateBackgorundOption: "Dewis cefndir dyblyg wedi'i ganfod",
  acknowledgmentNode: 'Cydnabyddiaeth',
  acknowledgmentText: 'Testun cydnabyddiaeth',
  acknowledgmentTextPlaceholder:
    "Nodwch eich testun sy'n disgrifio telerau ac amodau'r nod cydnabyddiaeth hwn",
  acknowledgmentButton: 'Teitl botwm derbyn',
  acknowledgmentButtonPlaceholder:
    'Setiwch deitl y botwm, e.e. Derbyn, Iawn, Cydnabod, Cadarnhau, ac ati.',
  replace: 'Cyfnewid nod',
  maxImageDuration: '*Uchafswm: 3 munud',
  openendedNodeTooltip: 'Cwestiwn agored (llwytho ffeil i fyny)',
  textAreaAnswerEnabled: 'Ateb ardal destun wedi’i alluogi',
  textAreaAnswerPrompt: 'Cynnig ar gyfer ateb yn yr ardal destun',
  maxCharacterCount: 'Uchafswm cymeriadau',
  attachmentAnswerEnabled: 'Ateb atodiad wedi’i alluogi',
  attachmentAnswerPrompt: 'Cynnig ar gyfer ateb atodiad',
  maxFileSizeKb: 'Uchafswm maint ffeil yn KB',
  gradeWeightEnabled: 'Pwysau gradd wedi’i alluogi',
  openEndedQuestionDefaultTestAreaPrompt:
    'Os gwelwch yn dda, llwythwch eich meddyliau ar y gwers fideo hyd yma i fyny',
  openEndedQuestionDefaultAttachmentPrompt:
    "Cyflwynwch ffeil sy'n ateb y cwestiwn canlynol",
  openEndedQuestionErrorBothPromptsDisabled:
    "Mae'r ddau gynnig ardal destun a thaflen atodiad wedi'u hatal",
  attachmentAnswerFileTypes:
    "Mathau ffeiliau (wedi'u gwahanu gan coma neu bysged):",
};

export const lessonEditorText: any = getLocalizationBasedOnLang(english, welsh);
